var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseIndentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98107 10.0007L5.6746 6.9025C5.88711 6.65806 5.88711 6.26175 5.6746 6.01731C5.46209 5.77288 5.11753 5.77288 4.90502 6.01731L1.8267 9.55806C1.61419 9.8025 1.61419 10.1988 1.8267 10.4432L4.90502 13.984C5.11753 14.2284 5.46209 14.2284 5.6746 13.984C5.88711 13.7396 5.88711 13.3432 5.6746 13.0988L2.98107 10.0007Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5.20898C7.5 4.86381 7.77982 4.58398 8.125 4.58398H18.5417C18.8868 4.58398 19.1667 4.86381 19.1667 5.20898C19.1667 5.55416 18.8868 5.83398 18.5417 5.83398H8.125C7.77982 5.83398 7.5 5.55416 7.5 5.20898Z",
    fill: "#7A7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83398 10.209C5.83398 9.86381 6.11381 9.58398 6.45898 9.58398L16.8757 9.58398C17.2208 9.58398 17.5007 9.86381 17.5007 10.209C17.5007 10.5542 17.2208 10.834 16.8757 10.834L6.45898 10.834C6.11381 10.834 5.83398 10.5542 5.83398 10.209Z",
    fill: "#7A7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15.209C7.5 14.8638 7.77982 14.584 8.125 14.584H18.5417C18.8868 14.584 19.1667 14.8638 19.1667 15.209C19.1667 15.5542 18.8868 15.834 18.5417 15.834H8.125C7.77982 15.834 7.5 15.5542 7.5 15.209Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseIndentIcon);
export default __webpack_public_path__ + "static/media/decrease_indent_icon.2fdb67de290b25630a5410ea35aff275.svg";
export { ForwardRef as ReactComponent };